export const REG_USER_NAME = /^[\u4E00-\u9FA5a-zA-Z0-9_-]{4,16}$/;

/**
 * Phone or Account reg
 *
 * Supports:
 *
 * 1. 11-digit phone number
 * 2. 8+ characters account name (letters, numbers, underscores)
 */
export const REG_PHONE =
  /^([1](([3][0-9])|([4][01456789])|([5][012356789])|([6][2567])|([7][0-8])|([8][0-9])|([9][012356789]))[0-9]{8}|[a-zA-Z0-9_]{8,})$/;

/**
 * Password reg
 *
 * 6-18 characters, including letters, numbers, and underscores
 */
export const REG_PWD = /^\w{6,18}$/;

/** Email reg */
export const REG_EMAIL = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

/** Four digit code reg */
export const REG_CODE_FOUR = /^\d{4}$/;

/** Six digit code reg */
export const REG_CODE_SIX = /^\d{6}$/;

/** Four to six digit code reg */
export const REG_CODE_FOUR_TO_SIX = /^\d{4,6}$/;

/** Url reg */
export const REG_URL =
  /(((^https?:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)$/;

/**
 * 金额正则表达式
 *
 * 匹配格式：
 *
 * 1. 允许正数
 * 2. 允许整数或最多两位小数
 * 3. 不允许以0开头的整数（除了0本身）
 */
export const REG_AMOUNT = /^([1-9]\d*|0)(\.\d{1,2})?$/;
